<template>
    <div>
        <validation-observer #default="{ invalid }" ref="observer">
            <span class="display-none">{{ invalid }}</span>
            <b-form ref="formular">
                <div class="white-box mt-3">
                    <div class="data-group">
                        <M3FormTitle id="v-step-0" title="Sediul social" :checked="completed"></M3FormTitle>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                label-cols-sm="2"
                                label-cols-lg="2"
                                content-cols-sm
                                content-cols-lg="10"
                                label="Sediul social"
                                class="mb-3 custom-responsive"
                            >
                                <b-form-input
                                    id="name"
                                    v-model="form.address"
                                    type="text"
                                    name="message"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                    @input="$emit('unsavedChanges', !!form.address)"
                                ></b-form-input>
                            </b-form-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                        <div class="flex flex-end mb-2 responsive-redefine">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="first-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="3"
                                    content-cols-lg="9"
                                    label="Județ"
                                    class="has-icon position-relative m-0 custom-responsive"
                                >
                                    <b-form-select
                                        v-model="form.state"
                                        :options="states"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        :class="completed ?'disabled-select':''"
                                    >
                                    </b-form-select>
                                    <small class="text-danger" style="position: relative !important; bottom: 0;">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="second-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                    label="Sector"
                                    class="has-icon custom-responsive"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.district"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.district)"
                                    ></b-form-input>
                                    <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="third-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                    label="Localitate"
                                    class="has-icon custom-responsive"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.city"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.city)"
                                    ></b-form-input>
                                    <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="quarter-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                    label="Strada"
                                    class="has-icon custom-responsive"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.street"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.street)"
                                    ></b-form-input>
                                    <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                        </div>
                        <div class="flex flex-end responsive-redefine">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="first-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="3"
                                    content-cols-lg="9"
                                    label="Număr strada"
                                    class="has-icon legend-center custom-responsive no-mt"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.street_no"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.street_no)"
                                    ></b-form-input>
                                    <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="second-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                    label="Bloc"
                                    class="has-icon custom-responsive"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.bl"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.bl)"
                                    ></b-form-input>
                                    <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="third-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                    label="Scară"
                                    class="has-icon custom-responsive"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.bl_no"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.bl_no)"
                                    ></b-form-input>
                                    <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="quarter-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                    label="Etaj"
                                    class="has-icon custom-responsive"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.floor"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.floor)"
                                    ></b-form-input>
                                    <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                        </div>
                        <div class="flex flex-end responsive-redefine">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="first-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                    label="Apartament"
                                    class="has-icon wider-input custom-responsive"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.apt"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.apt)"
                                    ></b-form-input>
                                    <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="second-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                    label="Cod poștal"
                                    class="has-icon custom-responsive"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.postal_code"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.postal_code)"
                                    ></b-form-input>
                                    <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="third-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                    label="Telefon"
                                    class="has-icon custom-responsive"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.phone"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.phone)"
                                    ></b-form-input>
                                    <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required|email"
                                class="quarter-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                    label="E-mail"
                                    class="has-icon custom-responsive"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.email"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.email)"
                                    ></b-form-input>
                                    <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>

                            </validation-provider>
                        </div>
                        <hr class="mt-5">
                        <b-form-checkbox
                            v-model="completed"
                            switch
                            size="lg"
                            class="switch-box"
                            @change="completeForm()"
                        >Informațiile sunt complete și corecte</b-form-checkbox>
                    </div>
                    <a href="https://termene.ro/" target="_blank">
                        <img src="@/assets/images/M3/M3Sketch/termenesmall.png" class="termene-icon">
                    </a>
                </div>
            </b-form>
        </validation-observer>
    </div>
</template>

<script>
    import { BForm, BFormInput, BFormGroup, BButton, BFormCheckbox, BFormSelect } from 'bootstrap-vue'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    import M3FormTitle from '../M3FormTitle'
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';

    export default {
        components: {
            BForm,
            BFormInput,
            BFormGroup,
            BButton,
            BFormCheckbox,
            BFormSelect,
            M3FormTitle,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            data: null,
            activeCompany: null,
        },
        data() {
            return {
                form: {
                    address: '',
                    state: '',
                    city: '',
                    district: '',
                    street: '',
                    street_no: '',
                    bl: '',
                    bl_no: '',
                    floor: '',
                    apt: '',
                    postal_code: '',
                    phone: this.$store.state.auth.user.phone,
                    email: this.$store.state.auth.user.email,
                },
                completed: false,
                states: null,
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            }
        },
        watch: {
            checks: {
                handler: function() {
                    this.completed = this.checks.companiaMeaSediuSocial;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            },
            data(newValue, oldValue){
                if(newValue !== oldValue){
                    this.form = this.data
                    if(this.data.apt === null) {
                        this.form.apt = '-'
                    }
                    if(this.data.bl === null) {
                        this.form.bl = '-'
                    }
                    if(this.data.bl_no === null) {
                        this.form.bl_no = '-'
                    }
                    if(this.data.floor === null) {
                        this.form.floor = '-'
                    }
                    if(this.data.district === null || this.data.district === '0') {
                        this.form.district = '-'
                    }
                    if(this.data.postal_code === null) {
                        this.form.postal_code = '-'
                    }
                }
            }
        },
        mounted() {
            axios.get(api.API_ROOT + '/states/RO')
                .then( response => {
                    this.states = response.data
                })
                .catch( xhr => {
                    console.log(xhr);
                })
            if(this.data !== null) {
                this.form = this.data
                if(this.data.apt === null) {
                    this.form.apt = '-'
                }
                if(this.data.bl === null) {
                    this.form.bl = '-'
                }
                if(this.data.bl_no === null) {
                    this.form.bl_no = '-'
                }
                if(this.data.floor === null) {
                    this.form.floor = '-'
                }
                if(this.data.district === null || this.data.district === '0') {
                    this.form.district = '-'
                }
                if(this.data.postal_code === null) {
                    this.form.postal_code = '-'
                }
            }
            if(!this.form.email || this.form.email === ''){
                this.form.email = this.$store.state.auth.user.email
            }
            if(!this.form.phone) {
                this.form.phone = this.$store.state.auth.user.phone
            }
        },
        methods: {
            completeForm() {
                this.$refs.observer.validate().then((e) => {
                    if(!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {
                        if(this.completed){
                            this.$store.dispatch('m3Sketch/saveAllDataPart', this.form)
                                .then((response) => {
                                    this.$toast.success(response.data.message)
                                }).catch((xhr) => {
                                    if (xhr.status === 422) {
                                        this.errors.record(xhr.responseJSON.errors);
                                    }
                                    this.$toast.error(xhr.response.data.message);
                                });
                        }
                    }
                    if(this.checks.companiaMeaSediuSocial !== this.completed)
                        this.$store.dispatch('checks/updateChecks', { name: 'companiaMeaSediuSocial', value: this.completed })
                })
            }
        },
    }
</script>

<style scoped>
.text-danger{
    width: 100%;
    white-space: pre;
    position: absolute;
    bottom: -20px;
}
.flex{
    display: flex;
}
.flex-end{
    justify-content: flex-end;
}
.first-input, .second-input{
    width: 21.5%;
}
.third-input, .quarter-input{
    width: 23%;
}
.custom-select{
    margin-bottom: 0;
    color: #767a95;
    padding: 5px 10px;
    max-height: 33px;
    font-size: 14px;
    border-radius: 2px;
    font-weight: 600;
    background: #e9ecef url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
}
.disabled-select{
    background: #a1fff1 url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
    pointer-events: none;
}
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.data-group{
    margin: auto;
    width: 90%;
}
.switch-box{
    text-align: right;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.form-group >>> legend{
    text-align: right;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
}
.form-group >>> input{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
.form-group >>> input:read-only{
    background: #a1fff1;
}
.form-group >>> .form-row{
    align-items: flex-start;
}
.inline-inputs{
    display: flex;
}
.inline-inputs input:first-child, .inline-inputs div:first-child{
    width: 25%;
    margin-right: 10px;
}
.inline-inputs div:first-child input{
    width: 100%;
}
.has-icon{
    position: relative;
}
.has-icon img{
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    right: 15px;
    opacity: 0.3;
}
.wider-input img{
    right: -4px;
}
.termene-icon{
    position: absolute;
    bottom: 15px;
    left: 20px;
}
.legend-center >>> legend{
    margin-top: -9px;
}
.wider-input >>> legend{
    margin-left: -20px;
}
.wider-input >>> input{
    width: 113%;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px;
    }
}
</style>
